// extracted by mini-css-extract-plugin
export default {"PurchaseItemsPage":"PurchaseItemsPage_PurchaseItemsPage__aDe-x"};